export default function formatEuro(number) {
  if (!number) return 0;
  return Number(Number(number).toFixed(2)).toLocaleString("es-ES", {minimumFractionDigits: 2});
}